/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDeleteListRequest, serializeFavoriteList, serializeRenameListRequest, type DeleteListRequest, type ErrorResponse, type FavoriteList, type InternalErrorResponse, type RenameListRequest } from '../../../../models/index.js';
// @ts-ignore
import { ItemsRequestBuilderNavigationMetadata, ItemsRequestBuilderRequestsMetadata, type ItemsRequestBuilder } from './items/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}/{favoriteListId}
 */
export interface WithFavoriteListItemRequestBuilder extends BaseRequestBuilder<WithFavoriteListItemRequestBuilder> {
    /**
     * The items property
     */
    get items(): ItemsRequestBuilder;
    /**
     * Deletes the list and every item on it outright — there is no soft delete and nothing to restore it from. Deleting the customer's default list does not promote another one, so the customer is left with no default until one is set again. Deleting a list that is already gone answers 404 rather than a silent success, so a retry after a successful delete reports not found.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one list by id, with its full items collection. The list must belong to the customer in the route as well as to the caller's organization; a list that exists but belongs to another customer or another organization answers 404 rather than 403, so the response never confirms that an id exists somewhere the caller cannot see.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithFavoriteListItemRequestBuilderGetQueryParameters> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Changes a list's display name. The name only: items, quantities and the default flag are untouched, and the list keeps its identifier, so saved links to it stay valid. Names are unique per customer, so a name another of that customer's lists already holds is a 400 — including the list's own current name, which makes re-sending the same rename fail the second time.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: RenameListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Deletes the list and every item on it outright — there is no soft delete and nothing to restore it from. Deleting the customer's default list does not promote another one, so the customer is left with no default until one is set again. Deleting a list that is already gone answers 404 rather than a silent success, so a retry after a successful delete reports not found.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one list by id, with its full items collection. The list must belong to the customer in the route as well as to the caller's organization; a list that exists but belongs to another customer or another organization answers 404 rather than 403, so the response never confirms that an id exists somewhere the caller cannot see.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithFavoriteListItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Changes a list's display name. The name only: items, quantities and the default flag are untouched, and the list keeps its identifier, so saved links to it stay valid. Names are unique per customer, so a name another of that customer's lists already holds is a 400 — including the list's own current name, which makes re-sending the same rename fail the second time.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: RenameListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns one list by id, with its full items collection. The list must belong to the customer in the route as well as to the caller's organization; a list that exists but belongs to another customer or another organization answers 404 rather than 403, so the response never confirms that an id exists somewhere the caller cannot see.
 */
export interface WithFavoriteListItemRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithFavoriteListItemRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}/{favoriteListId}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithFavoriteListItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithFavoriteListItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    items: {
        requestsMetadata: ItemsRequestBuilderRequestsMetadata,
        navigationMetadata: ItemsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithFavoriteListItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithFavoriteListItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteListRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithFavoriteListItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithFavoriteListItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRenameListRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
